import React, { createContext, useState, useContext, useMemo } from 'react';

const PhotoContext = createContext();

export const PhotoProvider = ({ children }) => {
  const [terminal, setTerminal] = useState(null);
  const [campaign, setCampaign] = useState(null);
  const [activeSite, setActiveSite] = useState(null);

  const value = useMemo(() => ({
    terminal,
    campaign,
    activeSite,
    setTerminal,
    setCampaign,
    setActiveSite,
  }), [terminal, campaign, activeSite]);

  return (
    <PhotoContext.Provider value={value}>
      {children}
    </PhotoContext.Provider>
  );
};

export const usePhotoContext = () => {
  const context = useContext(PhotoContext);
  if (!context) {
    throw new Error('usePhotoContext must be used within PhotoProvider');
  }
  return context;
};

export default PhotoContext;
